import { PublicCodeComparisonTemplate, PublicTemplate } from "../../../templates";

const CodeComparison = (): JSX.Element => {
  return (
    <PublicTemplate activeElement="Codes and Standards" isContentUnwrapped>
      <PublicCodeComparisonTemplate />
    </PublicTemplate>
  );
};

export default CodeComparison;
